import { render, staticRenderFns } from "./FinanceItemsRevenue.vue?vue&type=template&id=515d2376&scoped=true&"
import script from "./FinanceItemsRevenue.vue?vue&type=script&lang=js&"
export * from "./FinanceItemsRevenue.vue?vue&type=script&lang=js&"
import style0 from "./FinanceItemsRevenue.vue?vue&type=style&index=0&id=515d2376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d2376",
  null
  
)

export default component.exports